/**
 * Where a learner stands on a brief assigned to them, individually or as a group.
 *
 * Derived by the API from the assignment row: the client never computes it, so a card badge
 * and a filtered count can never disagree.
 */
export enum LearnerAssignmentStatus {
    TODO = "todo",
    IN_PROGRESS = "in-progress",
    SUBMITTED = "submitted",
    CORRECTED = "corrected",
}
